import HARDCODE from '../../../business-const/HardCode/HardCode'

import {
    obtemTextoArray,
} from '../../../business-components/Array/Array'

import {
    ano,
    mes,
    dia,
    dataAnoMesDia,
    identificaDataComBaseSiglaMesAnoString,
    //calculaMeses2Datas,
    //somaMesesData,
} from '../../../business-components/Date/Date'

import {
    round
} from '../../../business-components/round/round'

import {
    pesquisaList,
} from '../../../business-rules/List/ListService'

import {
    calculaValorAnual,
} from '../cliente-form/ClienteService'

import {
    trataTexto,
    trataValor,
    trataValorTexto,
    trataPercentualTexto,
    trataData,
} from '../cliente-form/ClienteServiceImportacao'

//import {
//    converteTaxaEmMensal,
//    converteTaxaMensalEmAnual,
//} from '../estudo-form/EstudoServiceMatematicaFinanceira'

import {
    espaco,
    fimLinha,
    identificaTipoCoberturaSeguroVida,
    identificaStatusCobertura,
    indexAtualJsonRegistros,
    obtemDadoPDF,
    obtemDadoPDFAvulso,
    obtemDadoXLSX,
    jsonRegistrosInicializacao,
    jsonRegistrosJsonRegistrosInicializacao,
    jsonRegistrosJsonRegistrosAtualizaErros,
    incluiCoberturas,
    numeroCotacaoAutomatico,
    incluiTabelaEvolucaoValorResgateCoberturaVidaInteira,
    incluiPosicaoInvestimentos,
} from './IntegracaoClienteArquivoService'



export const importaPropostaXP = (PDFTxt, idUsuarioLogado, vars, equipeList, linhaIntegracao, seguradora,
    nomeArquivo, erros, variaveisGlobais) => {

    const jsonRegistros = jsonRegistrosInicializacao()

    jsonRegistros.jsonRegistros.push(jsonRegistrosJsonRegistrosInicializacao(erros))

    const indexJsonRegistros = indexAtualJsonRegistros(jsonRegistros)

    
    
    //PDFTxt = PDFTxt.replace(fimLinha + 'Complemento:' + fimLinha + 'Bairro:' + fimLinha, 
    //    fimLinha + 'Complemento:' + fimLinha + '' + fimLinha + 'Bairro:' + fimLinha)



    obtemDadoPDF(PDFTxt, jsonRegistros, espaco + 'Data da Proposta' + espaco, fimLinha,
        HARDCODE.importacaoDataAssinatura, true, null, erros, nomeArquivo)
        
    obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Nº Proposta' + espaco, fimLinha,
        HARDCODE.importacaoNumeroProposta, true, null, erros, nomeArquivo)

    jsonRegistros.jsonRegistros[indexJsonRegistros].statusProposta = HARDCODE.idStatusPropostaPendente

    obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Nome Completo' + fimLinha, fimLinha,
        HARDCODE.importacaoNomeSeguradoCliente, true, null, erros, nomeArquivo)

    obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'E-mail' + fimLinha, fimLinha,
        HARDCODE.importacaoEmailSeguradoCliente, true, null, erros, nomeArquivo)

    obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'CPF' + fimLinha, fimLinha, 
        HARDCODE.importacaoCpfSeguradoCliente, true, null, erros, nomeArquivo)

    obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Data de Nascimento' + fimLinha, fimLinha, 
        HARDCODE.importacaoNascimentoSeguradoCliente, true, null, erros, nomeArquivo)

    obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Telefone Celular' + fimLinha, espaco + 'Masculino',
        HARDCODE.importacaoCelularSeguradoCliente, true, null, erros, nomeArquivo)
        
    //obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Sexo:' + fimLinha, fimLinha,
    //    HARDCODE.importacaoSexoSeguradoCliente, true, null, erros, nomeArquivo)

    obtemDadoPDF(PDFTxt, jsonRegistros, espaco + 'Periodicidade de Pagamento' + espaco, fimLinha,
        HARDCODE.importacaoTipoPeriodicidadePagtoPremio, true, null, erros, nomeArquivo)

    obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Prazo' + fimLinha + 'Vigência' + fimLinha + 'Prazo' + fimLinha + 'Pagamento',
        fimLinha + 'Prêmio anual total' + fimLinha, HARDCODE.importacaoPropostaCoberturas, true, null, erros, nomeArquivo)



    if (jsonRegistros.jsonRegistros[indexJsonRegistros].propostaCoberturas) {

        const linhasCobertura = jsonRegistros.jsonRegistros[indexJsonRegistros].propostaCoberturas.split(fimLinha)
        let indexLinhasCobertura = -1


        
        const coberturas = []

        let numeroCobertura
        let codigoCobertura
        let descricaoCobertura
        let dadosCobertura
        let valorCS
        let valorPremioLiquido
        let valorIof
        let valorPremio
        let classeAjusteRisco
        let valorPremioExtra = ''
        let duracaoPremioExtra = ''
        let dataTerminoCobertura
        let valorRendaMensal = ''

        indexLinhasCobertura = 0

        while (indexLinhasCobertura < linhasCobertura.length) {

            dadosCobertura = linhasCobertura[indexLinhasCobertura].split(espaco)
            
            valorCS = trataValorTexto(dadosCobertura[dadosCobertura.length - 4])
            valorPremioLiquido = ''
            valorIof = ''
            valorPremio = trataValorTexto(dadosCobertura[dadosCobertura.length - 6])
            classeAjusteRisco = trataTexto(dadosCobertura[dadosCobertura.length - 8])

            if (dadosCobertura[dadosCobertura.length - 3] === 'VITALÍCIO') {

                dataTerminoCobertura = dataAnoMesDia(
                    ano(jsonRegistros.jsonRegistros[indexJsonRegistros].nascimentoSeguradoCliente) + 100/* - 1*/,
                    mes(jsonRegistros.jsonRegistros[indexJsonRegistros].dataAssinatura),
                    dia(jsonRegistros.jsonRegistros[indexJsonRegistros].dataAssinatura)
                )

            } else {

                dataTerminoCobertura = trataData(dadosCobertura[dadosCobertura.length - 3])
            } 

            descricaoCobertura = ''

            let indexLinhasCoberturaAux = 0

            while (indexLinhasCoberturaAux < dadosCobertura.length - 8) {
            
                descricaoCobertura += (descricaoCobertura ? espaco : '') + dadosCobertura[indexLinhasCoberturaAux]
            
                indexLinhasCoberturaAux++
            }

            const tipoCoberturaSeguroVida = identificaTipoCoberturaSeguroVida(descricaoCobertura, linhaIntegracao,
                jsonRegistros.jsonRegistros[indexJsonRegistros], nomeArquivo, erros)

            incluiCoberturas(coberturas, numeroCobertura, codigoCobertura, descricaoCobertura, tipoCoberturaSeguroVida, null,
                valorCS, valorPremioLiquido, valorIof, valorPremio, classeAjusteRisco, valorPremioExtra, duracaoPremioExtra,
                    dataTerminoCobertura, valorRendaMensal)

            indexLinhasCobertura += 1
        }

        jsonRegistros.jsonRegistros[indexJsonRegistros].propostaCoberturas = coberturas

    }



    jsonRegistrosJsonRegistrosAtualizaErros(jsonRegistros, erros)
    


    return jsonRegistros.jsonRegistros
}



export const importaApoliceXP = (PDFTxt, idUsuarioLogado, vars, equipeList, linhaIntegracao, seguradora,
    nomeArquivo, erros, variaveisGlobais) => {

    const jsonRegistros = jsonRegistrosInicializacao()

    jsonRegistros.jsonRegistros.push(jsonRegistrosJsonRegistrosInicializacao(erros))

    const indexJsonRegistros = indexAtualJsonRegistros(jsonRegistros)

    //PDFTxt = PDFTxt.replaceAll('\u0000', 'r')

    //PDFTxt = PDFTxt.replaceAll('Prorssão', 'Profissão')
    
    //PDFTxt = PDFTxt.replaceAll(espaco + 'atéR$' + espaco, espaco + 'até R$' + espaco)

    //PDFTxt = PDFTxt.replaceAll(espaco + 'deR$' + espaco, espaco + 'de R$' + espaco)

    //PDFTxt = PDFTxt.replaceAll(espaco + 'Nãoaplicado' + espaco, espaco + 'Não aplicado' + espaco)


    
    obtemDadoPDF(PDFTxt, jsonRegistros, espaco + 'Data de Emissão' + espaco, fimLinha, 
        HARDCODE.importacaoDataEmissao, true, null, erros, nomeArquivo)

    obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Apólice' + espaco, espaco,
        HARDCODE.importacaoNumeroApolice, true, null, erros, nomeArquivo)

    obtemDadoPDF(PDFTxt, jsonRegistros, espaco + 'Proposta' + espaco, fimLinha,
        HARDCODE.importacaoNumeroProposta, true, null, erros, nomeArquivo)

    obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Nome Completo' + fimLinha, fimLinha,
        HARDCODE.importacaoNomeSeguradoCliente, true, null, erros, nomeArquivo)

    obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'E-mail' + fimLinha, fimLinha,
        HARDCODE.importacaoEmailSeguradoCliente, true, null, erros, nomeArquivo)

    obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'CPF' + fimLinha, fimLinha,
        HARDCODE.importacaoCpfSeguradoCliente, true, null, erros, nomeArquivo)

    obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Data de Nascimento' + fimLinha, fimLinha,
        HARDCODE.importacaoNascimentoSeguradoCliente, true, null, erros, nomeArquivo)

    obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Telefone Celular' + fimLinha, fimLinha,
        HARDCODE.importacaoCelularSeguradoCliente, true, null, erros, nomeArquivo)
    
    //obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Sexo' + fimLinha, fimLinha,
    //    HARDCODE.importacaoSexoSeguradoCliente, true, null, erros, nomeArquivo)

    obtemDadoPDF(PDFTxt, jsonRegistros, espaco + 'Periodicidade de Pagamento' + espaco, fimLinha,
        HARDCODE.importacaoTipoPeriodicidadePagtoPremio, true, null, erros, nomeArquivo)

    obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Forma de pagamento' + espaco, espaco + 'Dia de Vencimento' + espaco,
        HARDCODE.importacaoTipoFormaPagtoPremio, true, null, erros, nomeArquivo)

    obtemDadoPDF(PDFTxt, jsonRegistros, espaco + 'Dia de Vencimento' + espaco, fimLinha,
        HARDCODE.importacaoDiaVencimento, true, null, erros, nomeArquivo)

    //obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Profissão' + fimLinha, fimLinha, 
    //    HARDCODE.importacaoProfissaoSegurado, false, null, erros, nomeArquivo)

    //obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + '02 Endereço Residencial' + fimLinha + 'Cidade' + fimLinha, fimLinha,
    //    HARDCODE.importacaoCidadeSeguradoCliente, true, null, erros, nomeArquivo)

    //obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Estado' + fimLinha, fimLinha,
    //    HARDCODE.importacaoUfSeguradoCliente, true, null, erros, nomeArquivo)

    //obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Rua' + fimLinha, fimLinha,
    //    HARDCODE.importacaoEnderecoSeguradoCliente, true, null, erros, nomeArquivo)
        
    //obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Bairro' + fimLinha, fimLinha,
    //    HARDCODE.importacaoBairroSeguradoCliente, true, null, erros, nomeArquivo)

    //obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'CEP' + fimLinha, fimLinha,
    //    HARDCODE.importacaoCepSeguradoCliente, true, null, erros, nomeArquivo)

    //obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Número' + fimLinha, fimLinha,
    //    HARDCODE.importacaoNumeroEnderecoSeguradoCliente, true, null, erros, nomeArquivo)

    //obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Complemento' + fimLinha, fimLinha + '03 Dados da apólice' + fimLinha,
    //    HARDCODE.importacaoComplementoEnderecoSeguradoCliente, false, null, erros, nomeArquivo)

    jsonRegistros.jsonRegistros[indexJsonRegistros].statusApolice = HARDCODE.idStatusApoliceAtiva
    //obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Status da Apólice:' + espaco, fimLinha,
    //    HARDCODE.importacaoStatusApolice, true, linhaIntegracao.statusApolice, erros, nomeArquivo)

    obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Capital' + fimLinha + 'Segurado' + fimLinha + 'Prazo' +
        fimLinha + 'Vigência' + fimLinha + 'Prazo' + fimLinha + 'Pagamento' + fimLinha,
            fimLinha + 'Prêmio mensal total' + espaco, HARDCODE.importacaoCoberturas, true, null, erros, nomeArquivo)

    if (jsonRegistros.jsonRegistros[indexJsonRegistros].coberturas) {
        
        const linhasCobertura = []
        let indexLinhasCobertura = 0

        const linhasCoberturaAux = jsonRegistros.jsonRegistros[indexJsonRegistros].coberturas.split(fimLinha)
        let indexLinhasPosicaoAux = 0
        //let linhaCoberturaAux = ''

        const coberturas = []

        let dadosCobertura
        let indexDadosCobertura

        let numeroCobertura
        let codigoCobertura
        let descricaoCobertura
        let tipoCoberturaSeguroVida
        let valorCS
        let valorPremioLiquido
        let valorIof
        let valorPremio
        let classeAjusteRisco
        let valorPremioExtra
        let duracaoPremioExtra
        let dataTerminoCobertura
        let valorRendaMensal

        while (indexLinhasPosicaoAux < linhasCoberturaAux.length) {

            if (linhasCoberturaAux[indexLinhasPosicaoAux].trim()) {

                linhasCobertura.push(linhasCoberturaAux[indexLinhasPosicaoAux])
            }

            indexLinhasPosicaoAux += 1
        }

        while (indexLinhasCobertura < linhasCobertura.length) {

            dadosCobertura = linhasCobertura[indexLinhasCobertura].split(espaco)

            indexDadosCobertura = 0

            descricaoCobertura = ''

            while (indexDadosCobertura < dadosCobertura.length && dadosCobertura[indexDadosCobertura] !== 'R$') {

                descricaoCobertura += (descricaoCobertura ? espaco : '') + dadosCobertura[indexDadosCobertura]

                indexDadosCobertura++
            }

            tipoCoberturaSeguroVida = identificaTipoCoberturaSeguroVida(descricaoCobertura, linhaIntegracao,
                jsonRegistros.jsonRegistros[indexJsonRegistros], nomeArquivo, erros)

            valorCS = trataValorTexto(dadosCobertura[indexDadosCobertura + 2])
            valorPremio = trataValorTexto(dadosCobertura[indexDadosCobertura + 1])

            if (dadosCobertura[indexDadosCobertura + 3] === 'VITALÍCIO') {

                dataTerminoCobertura =
                    dataAnoMesDia(
                        ano(jsonRegistros.jsonRegistros[indexJsonRegistros].nascimentoSeguradoCliente) + 100/* - 1*/,
                        mes(jsonRegistros.jsonRegistros[indexJsonRegistros].dataEmissao),
                        dia(jsonRegistros.jsonRegistros[indexJsonRegistros].dataEmissao)
                    )

            } else {

                dataTerminoCobertura = trataData(dadosCobertura[indexDadosCobertura + 3])
            }

            incluiCoberturas(coberturas, numeroCobertura, codigoCobertura, descricaoCobertura, tipoCoberturaSeguroVida,
                HARDCODE.idStatusCoberturaAtivaPagandoPremio, valorCS, valorPremioLiquido, valorIof, valorPremio,
                    classeAjusteRisco, valorPremioExtra, duracaoPremioExtra, dataTerminoCobertura, valorRendaMensal)
            
            indexLinhasCobertura++
        }

        jsonRegistros.jsonRegistros[indexJsonRegistros].coberturas = coberturas
    }


    
    jsonRegistrosJsonRegistrosAtualizaErros(jsonRegistros, erros)



    return jsonRegistros.jsonRegistros
}



export const importaListaApolicesXPImplantacao = (XLSX, idUsuarioLogado, vars, equipeList, linhaIntegracao, seguradora,
    nomeArquivo, erros, variaveisGlobais) => {

    //const timeSeguradoraAux = timeSeguradora(idUsuarioLogado, equipeList, seguradora)

    let jsonRegistros = jsonRegistrosInicializacao()

    let linha = linhaIntegracao.cabecalho + 1

    while (linha < XLSX.length) {

        if (XLSX[linha][1]) {

            jsonRegistros.jsonRegistros.push(jsonRegistrosJsonRegistrosInicializacao(erros))

            

            //const usuarioClienteSelecionado = idUsuarioLogado//idAgenteTimeSeguradora(timeSeguradoraAux, XLSX[linha][38])

            const indexJsonRegistros = indexAtualJsonRegistros(jsonRegistros)

           

            obtemDadoXLSX(XLSX, jsonRegistros, linha, 1, HARDCODE.importacaoNumeroApolice, true, null, erros, nomeArquivo)

            //obtemDadoXLSX(XLSX, jsonRegistros, linha, ?, HARDCODE.importacaoNumeroProposta, true, null, erros, nomeArquivo)
    
            obtemDadoXLSX(XLSX, jsonRegistros, linha, 13, HARDCODE.importacaoStatusApolice, true, linhaIntegracao.statusApolice,
                erros, nomeArquivo)

            obtemDadoXLSX(XLSX, jsonRegistros, linha, 5, HARDCODE.importacaoDataEmissao, true, null, erros, nomeArquivo)
            
            obtemDadoXLSX(XLSX, jsonRegistros, linha, 3, HARDCODE.importacaoNomeSeguradoCliente, true, null, erros, nomeArquivo)

            obtemDadoXLSX(XLSX, jsonRegistros, linha, 2, HARDCODE.importacaoCpfSeguradoCliente, true, null, erros, nomeArquivo)

            obtemDadoXLSX(XLSX, jsonRegistros, linha, 4, HARDCODE.importacaoNascimentoSeguradoCliente, true, null, erros, nomeArquivo)

            //obtemDadoXLSX(XLSX, jsonRegistros, linha, ?, HARDCODE.importacaoSexoSeguradoCliente, true, null, erros, nomeArquivo)
            
            //obtemDadoXLSX(XLSX, jsonRegistros, linha, ?, HARDCODE.importacaoProfissaoSegurado, true, null, erros, nomeArquivo)

            //obtemDadoXLSX(XLSX, jsonRegistros, linha, ?, HARDCODE.importacaoEnderecoSeguradoCliente, true, null, erros, nomeArquivo)

            //if (jsonRegistros.jsonRegistros[indexJsonRegistros].enderecoSeguradoCliente) {
            //
            //    jsonRegistros.jsonRegistros[indexJsonRegistros].enderecoSeguradoCliente =
            //        jsonRegistros.jsonRegistros[indexJsonRegistros].enderecoSeguradoCliente.replace('CEP:' + espaco, '')
            //
            //    const endereco = jsonRegistros.jsonRegistros[indexJsonRegistros].enderecoSeguradoCliente.split('-')
            //
            //    const tamEndereco = endereco.length
            //
            //    jsonRegistros.jsonRegistros[indexJsonRegistros].cepSeguradoCliente = endereco[tamEndereco - 2].trim()
            //    jsonRegistros.jsonRegistros[indexJsonRegistros].ufSeguradoCliente = endereco[tamEndereco - 3].trim()
            //    jsonRegistros.jsonRegistros[indexJsonRegistros].cidadeSeguradoCliente = endereco[tamEndereco - 4].trim()
            //    jsonRegistros.jsonRegistros[indexJsonRegistros].bairroSeguradoCliente = endereco[tamEndereco - 5].trim()
            //    jsonRegistros.jsonRegistros[indexJsonRegistros].complementoEnderecoSeguradoCliente = endereco[tamEndereco - 6].trim()
            //    jsonRegistros.jsonRegistros[indexJsonRegistros].numeroEnderecoSeguradoCliente = endereco[tamEndereco - 7].trim()
            //
            //    if (tamEndereco === 10) {
            //        
            //        jsonRegistros.jsonRegistros[indexJsonRegistros].enderecoSeguradoCliente =
            //            endereco[0].trim() + espaco + endereco[1].trim() + '-' + endereco[2].trim()
            //
            //    } else {
            //
            //        jsonRegistros.jsonRegistros[indexJsonRegistros].enderecoSeguradoCliente =
            //            endereco[0].trim() + espaco + endereco[1].trim()
            //    }
            //}

            //obtemDadoXLSX(XLSX, jsonRegistros, linha, ?, HARDCODE.importacaoCelularSeguradoCliente, true, null, erros, nomeArquivo)

            //obtemDadoXLSX(XLSX, jsonRegistros, linha, ?, HARDCODE.importacaoEmailSeguradoCliente, false, null, erros, nomeArquivo)
            
            //obtemDadoXLSX(XLSX, jsonRegistros, linha, ?, HARDCODE.importacaoRendaMensal, false/*true*/, null, erros, nomeArquivo)
           
            obtemDadoXLSX(XLSX, jsonRegistros, linha, 8, HARDCODE.importacaoTipoPeriodicidadePagtoPremio, true, null, erros, nomeArquivo)

            obtemDadoXLSX(XLSX, jsonRegistros, linha, 11, HARDCODE.importacaoTipoFormaPagtoPremio, true, null, erros, nomeArquivo)
            
            obtemDadoXLSX(XLSX, jsonRegistros, linha, 12, HARDCODE.importacaoDiaVencimento, true, null, erros, nomeArquivo)
            
            //obtemDadoXLSX(XLSX, jsonRegistros, linha, 54, HARDCODE.importacaoCnpjEmpresa, true, null, erros, nomeArquivo)

            //jsonRegistros.jsonRegistros[indexJsonRegistros].cnpjEmpresa =
            //    converterCnpjEmpresa(vars, jsonRegistros.jsonRegistros[indexJsonRegistros].cnpjEmpresa)
            
            //if (usuarioClienteSelecionado) {
               
                //jsonRegistros.jsonRegistros[indexJsonRegistros].usuarioClienteSelecionado = usuarioClienteSelecionado
            
                const coberturas = []

                let valorPremioAnualizado = 0

                while (
                    linha < XLSX.length &&
                    '' + XLSX[linha][1] === jsonRegistros.jsonRegistros[indexJsonRegistros].numeroApolice
                ) {

                    valorPremioAnualizado = round(valorPremioAnualizado + XLSX[linha][9], 2)

                    let numeroCobertura
                    let codigoCobertura
                    let descricaoCobertura
                    let tipoCoberturaSeguroVida
                    let valorCS
                    let valorPremioLiquido
                    let valorIof
                    let valorPremio
                    let classeAjusteRisco
                    let valorPremioExtra
                    let duracaoPremioExtra
                    let dataTerminoCobertura
                    let valorRendaMensal

                    tipoCoberturaSeguroVida = identificaTipoCoberturaSeguroVida(trataTexto(XLSX[linha][7]),
                        linhaIntegracao, jsonRegistros.jsonRegistros[indexJsonRegistros], nomeArquivo, erros)

                    if (tipoCoberturaSeguroVida) {

                        //numeroCobertura = XLSX[linha][15/*14*/]
                        //codigoCobertura = XLSX[linha][20/*19*/].substring(XLSX[linha][20/*19*/].length - 4)
                        descricaoCobertura = trataTexto(XLSX[linha][7])
                        valorCS = trataValor(XLSX[linha][10], HARDCODE.typeValor, null)
                        valorPremioLiquido = ''
                        valorIof = ''
                        valorPremio = trataValor(XLSX[linha][9], HARDCODE.typeValor, null)

                        //if (XLSX[linha][27/*23*/]) {

                        dataTerminoCobertura = trataData(XLSX[linha][6])

                        //} else {

                        //    dataTerminoCobertura = dataAnoMesDia(
                        //        ano(jsonRegistros.jsonRegistros[indexJsonRegistros].nascimentoSeguradoCliente) + 100/* - 1*/,
                        //        mes(jsonRegistros.jsonRegistros[indexJsonRegistros].dataEmissao),
                        //        dia(jsonRegistros.jsonRegistros[indexJsonRegistros].dataEmissao)
                        //    )
                        //}

                        const statusCobertura = identificaStatusCobertura(trataTexto(XLSX[linha][13]), linhaIntegracao,
                            jsonRegistros.jsonRegistros[indexJsonRegistros], nomeArquivo, erros)

                        incluiCoberturas(coberturas, numeroCobertura, codigoCobertura, descricaoCobertura, tipoCoberturaSeguroVida,
                            statusCobertura, valorCS, valorPremioLiquido, valorIof, valorPremio,
                                classeAjusteRisco, valorPremioExtra, duracaoPremioExtra, dataTerminoCobertura, valorRendaMensal)
                    }

                    linha++
                }

                jsonRegistros.jsonRegistros[indexJsonRegistros].valorPremioAnualizado = 
                    calculaValorAnual(valorPremioAnualizado,
                        jsonRegistros.jsonRegistros[indexJsonRegistros].tipoPeriodicidadePagtoPremio) 

                jsonRegistros.jsonRegistros[indexJsonRegistros].coberturas = coberturas

            //} else {

            //    erros.push(MESSAGE().agenteNaoEncontradoApolice
            //        .replace("$numeroApolice$", jsonRegistros.jsonRegistros[indexJsonRegistros].numeroApolice)
            //            .replace("$codigoAgente$", XLSX[linha][38])
            //    )

            //    linha++
            //}

            jsonRegistrosJsonRegistrosAtualizaErros(jsonRegistros, erros)

        } else {

            linha++
        }
    }

    return jsonRegistros.jsonRegistros
}



export const importaCotacaoXPTabelaEvolucaoValorResgate = (values, item, linhaIntegracaoCotacao,
    PDFTxt, nomeArquivo, erros) => {

    const jsonRegistros = jsonRegistrosInicializacao()

    jsonRegistros.jsonRegistros.push(jsonRegistrosJsonRegistrosInicializacao(erros))

    const indexJsonRegistros = indexAtualJsonRegistros(jsonRegistros)
    
    obtemDadoPDF(PDFTxt, jsonRegistros, /*fimLinha + */'foi realizada no dia' + espaco, '.' + fimLinha,
        HARDCODE.importacaoDataCotacao, true, null, erros, nomeArquivo)

    obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Ano Idade Prêmio Capital Segurado Valor de Resgate' + fimLinha,
        fimLinha + 'Possíveis reajustes' + fimLinha,
            HARDCODE.importacaoTabelaEvolucaoValorResgate, false, null, erros, nomeArquivo)

    if (jsonRegistros.jsonRegistros[indexJsonRegistros].tabelaEvolucaoValorResgate) {

        const linhasTabelaEvolucaoValorResgateAux =
            jsonRegistros.jsonRegistros[indexJsonRegistros].tabelaEvolucaoValorResgate.split(fimLinha)
        let indexLinhasTabelaEvolucaoValorResgateAux = 0

        const linhasTabelaEvolucaoValorResgate = []
        let indexLinhasTabelaEvolucaoValorResgate = 0

        let numeroCotacao = numeroCotacaoAutomatico()
        let dataCotacao = jsonRegistros.jsonRegistros[indexJsonRegistros].dataCotacao
        let ano
        let idade
        let valorCS
        let valorPremioAnualizadoAcumulado
        let valorResgate
        let valorSaldado
        let beneficioProlongado

        item.tabelaEvolucaoValorResgate = []

        let dadosTabelaEvolucaoValorResgate

        while (indexLinhasTabelaEvolucaoValorResgateAux < linhasTabelaEvolucaoValorResgateAux.length) {

            if (
                    linhasTabelaEvolucaoValorResgateAux[indexLinhasTabelaEvolucaoValorResgateAux].indexOf('R$') !== -1
            ) {

                linhasTabelaEvolucaoValorResgate.push(
                    linhasTabelaEvolucaoValorResgateAux[indexLinhasTabelaEvolucaoValorResgateAux]
                )
            }

            indexLinhasTabelaEvolucaoValorResgateAux++
        }

        while (indexLinhasTabelaEvolucaoValorResgate < linhasTabelaEvolucaoValorResgate.length) {

            dadosTabelaEvolucaoValorResgate =
                linhasTabelaEvolucaoValorResgate[indexLinhasTabelaEvolucaoValorResgate]
                    .replaceAll('R$ ','R$' + espaco)
                    .split(espaco)

            ano = Number.parseInt(dadosTabelaEvolucaoValorResgate[0])

            idade = Number.parseInt(dadosTabelaEvolucaoValorResgate[1])
            valorCS = trataValorTexto(dadosTabelaEvolucaoValorResgate[5])
            valorPremioAnualizadoAcumulado = trataValorTexto(dadosTabelaEvolucaoValorResgate[3])

            //if (ano === 1 && valorPremioAnualizadoAcumulado === 0) {

                //jsonRegistros.indexInicial = 0

                //obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'TOTAL DE CONTRIBUIÇÃO' + espaco, fimLinha,
                //    HARDCODE.importacaoValorPremioAnualizado, true, null, erros, nomeArquivo)

            //    valorPremioAnualizadoAcumulado =
            //        jsonRegistros.jsonRegistros[indexJsonRegistros].valorPremioAnualizado
            //}

            valorResgate = trataValorTexto(dadosTabelaEvolucaoValorResgate[7])
            valorSaldado = ''
            beneficioProlongado = ''
            
            incluiTabelaEvolucaoValorResgateCoberturaVidaInteira(values, item, numeroCotacao, dataCotacao, ano, idade, valorCS,
                valorPremioAnualizadoAcumulado, valorResgate, valorSaldado, beneficioProlongado, null, null)

            indexLinhasTabelaEvolucaoValorResgate++
        }
    }



    
    //jsonRegistrosJsonRegistrosAtualizaErros(jsonRegistros, erros)



    //return jsonRegistros.jsonRegistros
}



export const importaFichaCadastralXP = (PDFTxt, idUsuarioLogado, vars, equipeList, linhaIntegracao, seguradora,
    nomeArquivo, erros, variaveisGlobais) => {

    const jsonRegistros = jsonRegistrosInicializacao()

    jsonRegistros.jsonRegistros.push(jsonRegistrosJsonRegistrosInicializacao(erros))

    const indexJsonRegistros = indexAtualJsonRegistros(jsonRegistros)

    //PDFTxt = PDFTxt.replaceAll('\u0000', 'r')

    //PDFTxt = PDFTxt.replaceAll('Prorssão', 'Profissão')
    


    obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'CNPJ da entidade:' + fimLinha,
        fimLinha + 'DADOS DE IDENTIFICAÇÃO DO REPRESENTANTE/ PROCURADOR (SE HOUVER)' + fimLinha,
            HARDCODE.importacaoLinhaDados, false, null, erros, nomeArquivo)

    let linhasDados = jsonRegistros.jsonRegistros[indexJsonRegistros].linhaDados.split(fimLinha)
    let linhaDados = linhasDados[0].split(espaco)
    let tamLinhaDados = linhaDados.length

    obtemDadoPDFAvulso (jsonRegistros, obtemTextoArray(linhaDados, 0, tamLinhaDados - 2),
        HARDCODE.importacaoNomeSeguradoCliente, true, null, erros, nomeArquivo)

    obtemDadoPDFAvulso (jsonRegistros, linhaDados[tamLinhaDados - 1],
        HARDCODE.importacaoCpfSeguradoCliente, true, null, erros, nomeArquivo)



    linhaDados = linhasDados[2].split(espaco)

    obtemDadoPDFAvulso (jsonRegistros, linhaDados[0],
        HARDCODE.importacaoNascimentoSeguradoCliente, true, null, erros, nomeArquivo)

    
    let indLinhasDados = 3

    while (linhasDados[indLinhasDados].indexOf('@') === -1) {

        indLinhasDados++
    }

    linhaDados = linhasDados[indLinhasDados].split(espaco)

    obtemDadoPDFAvulso (jsonRegistros, linhaDados[2] + linhaDados[3],
        HARDCODE.importacaoCelularSeguradoCliente, true, null, erros, nomeArquivo)

    obtemDadoPDFAvulso (jsonRegistros, linhaDados[4],
        HARDCODE.importacaoEmailSeguradoCliente, true, null, erros, nomeArquivo)



    indLinhasDados += 3

    while (
            linhasDados[indLinhasDados].substring(linhasDados[indLinhasDados].length - 4,
                linhasDados[indLinhasDados].length - 3) !== '-' ||
            isNaN(linhasDados[indLinhasDados].substring(linhasDados[indLinhasDados].length - 5,
                linhasDados[indLinhasDados].length - 4))
    ) {

        indLinhasDados++
    }

    //obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Sexo' + fimLinha, fimLinha,
    //    HARDCODE.importacaoSexoSeguradoCliente, true, null, erros, nomeArquivo)

    //obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Profissão' + fimLinha, fimLinha, 
    //    HARDCODE.importacaoProfissaoSegurado, false, null, erros, nomeArquivo)

    //obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + '02 Endereço Residencial' + fimLinha + 'Cidade' + fimLinha, fimLinha,
    //    HARDCODE.importacaoCidadeSeguradoCliente, true, null, erros, nomeArquivo)

    //obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Estado' + fimLinha, fimLinha,
    //    HARDCODE.importacaoUfSeguradoCliente, true, null, erros, nomeArquivo)

    obtemDadoPDFAvulso (jsonRegistros, linhasDados[indLinhasDados - 1],
        HARDCODE.importacaoEnderecoSeguradoCliente, true, null, erros, nomeArquivo)
        
    //obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Bairro' + fimLinha, fimLinha,
    //    HARDCODE.importacaoBairroSeguradoCliente, true, null, erros, nomeArquivo)

    obtemDadoPDFAvulso (jsonRegistros, linhasDados[indLinhasDados].split(fimLinha),
        HARDCODE.importacaoCepSeguradoCliente, true, null, erros, nomeArquivo)

    obtemDadoPDFAvulso (jsonRegistros, linhasDados[indLinhasDados + 1].split('-')[0],
        HARDCODE.importacaoNumeroConta, true, null, erros, nomeArquivo)

    //obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Número' + fimLinha, fimLinha,
    //    HARDCODE.importacaoNumeroEnderecoSeguradoCliente, true, null, erros, nomeArquivo)

    //obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Complemento' + fimLinha, fimLinha + '03 Dados da apólice' + fimLinha,
    //    HARDCODE.importacaoComplementoEnderecoSeguradoCliente, false, null, erros, nomeArquivo)

    if (linhasDados[linhasDados.length - 1].split(espaco).length === 1) { // Tratamento para os casos em que a renda do cliente não foi informada.
        
        obtemDadoPDFAvulso (jsonRegistros, linhasDados[linhasDados.length - 1],
            HARDCODE.importacaoRendaMensal, true, null, erros, nomeArquivo)
    }

        

    jsonRegistros.jsonRegistros[0].contasInvestimentos = []
    jsonRegistros.jsonRegistros[0].contasInvestimentos.push(
        {
             instituicaoFinanceira: HARDCODE.idInstituicaoFinanceiraXP,
             numeroConta: jsonRegistros.jsonRegistros[0].numeroConta,
        }
    )

    jsonRegistrosJsonRegistrosAtualizaErros(jsonRegistros, erros)



    return jsonRegistros.jsonRegistros
}



const trataCaixaProventos = (PDFTxt, jsonRegistros, erros, nomeArquivo, indexJsonRegistros, posicaoInvestimentos, caixaProventos) => {

    obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + caixaProventos + ' (', fimLinha,
        HARDCODE.importacaoLinhaDados, false, null, erros, nomeArquivo)
            
    if (jsonRegistros.jsonRegistros[indexJsonRegistros].linhaDados) {

        const linhaDados = jsonRegistros.jsonRegistros[indexJsonRegistros].linhaDados.split(espaco)

        const valor = trataValorTexto(linhaDados[linhaDados.length - 5])
        
        if (valor !== 0) {

            incluiPosicaoInvestimentos(posicaoInvestimentos, HARDCODE.idTipoRecursoFinanceiroContaCorrente, caixaProventos,
                    valor/*, percRentabilidadeAnualRecursoFinanceiro*/,
                        jsonRegistros.jsonRegistros[indexJsonRegistros].instituicaoFinanceira,
                            null, null, null, null, null, null, null, null, null, null)
        }
    }
}
   
export const importaPosicaoInvestimentosXP = (PDFTxt, idUsuarioLogado, vars, equipeList, linhaIntegracao, seguradora,
    nomeArquivo, erros, variaveisGlobais) => {

    const jsonRegistros = jsonRegistrosInicializacao()

    jsonRegistros.jsonRegistros.push(jsonRegistrosJsonRegistrosInicializacao(erros))

    const indexJsonRegistros = indexAtualJsonRegistros(jsonRegistros)

    PDFTxt = PDFTxt.replaceAll('\u0000', 'fi')
    //console.log(PDFTxt)



    jsonRegistros.jsonRegistros[indexJsonRegistros].instituicaoFinanceira = HARDCODE.idInstituicaoFinanceiraXP

    
    obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Conta Parceiro Data de Referência' + fimLinha, espaco,
        HARDCODE.importacaoNumeroConta, false, null, erros, nomeArquivo)
    
    if (!jsonRegistros.jsonRegistros[indexJsonRegistros].numeroConta) {

        obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Conta Assessor Data de Referência' + fimLinha, espaco,
            HARDCODE.importacaoNumeroConta, false, null, erros, nomeArquivo)

        if (!jsonRegistros.jsonRegistros[indexJsonRegistros].numeroConta) {

            obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Conta Banker Data de Referência' + fimLinha, espaco,
                HARDCODE.importacaoNumeroConta, true, null, erros, nomeArquivo)
        }
    }

    obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'PATRIMÔNIO TOTAL BRUTO:' + fimLinha, fimLinha,
        HARDCODE.importacaoPatrimonioTotalBruto, true, null, erros, nomeArquivo)

    obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'RENTABILIDADE MÊS:' + fimLinha, fimLinha,
        HARDCODE.importacaoRentabilidadeMes, true, null, erros, nomeArquivo)

    obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'GANHO MÊS:' + fimLinha, fimLinha,
        HARDCODE.importacaoGanhoMes, true, null, erros, nomeArquivo)

    obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'RENTABILIDADE INÍCIO:' + fimLinha, fimLinha,
        HARDCODE.importacaoRentabilidade24MesesOuDesdeInicio, false, null, erros, nomeArquivo)

    if (!jsonRegistros.jsonRegistros[indexJsonRegistros].rentabilidade24MesesOuDesdeInicio) {

        obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'RENTABILIDADE 24 MESES:' + fimLinha, fimLinha,
            HARDCODE.importacaoRentabilidade24MesesOuDesdeInicio, false, null, erros, nomeArquivo)

        if (!jsonRegistros.jsonRegistros[indexJsonRegistros].rentabilidade24MesesOuDesdeInicio) {

            obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'RENTABILIDADE (últimos 24M)' + fimLinha, fimLinha,
                HARDCODE.importacaoRentabilidade24MesesOuDesdeInicio, true, null, erros, nomeArquivo)
        }
    }

    obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'GANHO DESDE INÍCIO:' + fimLinha, fimLinha,
        HARDCODE.importacaoGanho24MesesOuDesdeInicio, false, null, erros, nomeArquivo)

    if (!jsonRegistros.jsonRegistros[indexJsonRegistros].ganho24MesesOuDesdeInicio) {

        obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'GANHO 24 MESES:' + fimLinha, fimLinha,
            HARDCODE.importacaoGanho24MesesOuDesdeInicio, false, null, erros, nomeArquivo)
            
        if (!jsonRegistros.jsonRegistros[indexJsonRegistros].ganho24MesesOuDesdeInicio) {

            obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'GANHO (últimos 24M)' + fimLinha, fimLinha,
                HARDCODE.importacaoGanho24MesesOuDesdeInicio, true, null, erros, nomeArquivo)
        }
    }

    obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Meses Positivos' + fimLinha, fimLinha,
        HARDCODE.importacaoMesesPositivos, true, null, erros, nomeArquivo)

    obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Meses Negativos' + fimLinha, fimLinha,
        HARDCODE.importacaoMesesNegativos, true, null, erros, nomeArquivo)

    obtemDadoPDF(PDFTxt, jsonRegistros, /*fimLinha + 'Relatório de Investimentos */espaco + 'Data de referência:' + espaco, fimLinha,
        HARDCODE.importacaoDataReferencia, true, null, erros, nomeArquivo)
    
    //obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Í N D I C E S  D E  R E F E R Ê N C I A' + fimLinha +
    //    'Benchmarks Mês Atual Ano 12M 24M' + fimLinha + 'CDI' + espaco, fimLinha,
    //        HARDCODE.importacaoTaxaCDI12Meses, true, null, erros, nomeArquivo)
    
    //jsonRegistros.jsonRegistros[indexJsonRegistros].taxaCDI12Meses =
    //    trataPercentualTexto(jsonRegistros.jsonRegistros[indexJsonRegistros].taxaCDI12Meses.split(espaco)[2])
    
    
    obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'P O S I Ç Ã O  D E T A L H A D A  D O S  AT I V O S' + fimLinha,
        fimLinha + 'M O V I M E N T A Ç Õ E S' + fimLinha +
            'M O V I M E N T A Ç Õ E S  D A  C O N T A  ( Ú LT I M O S  3 O  D I A S )' + fimLinha,
                HARDCODE.importacaoPosicaoInvestimentos, false, null, erros, nomeArquivo)
                
    if (!jsonRegistros.jsonRegistros[indexJsonRegistros].posicaoInvestimentos) {

        obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'P O S I Ç Ã O  D E T A L H A D A  D O S  AT I V O S' + fimLinha,
            fimLinha + 'M O V I M E N T A Ç Õ E S  D O  M Ê S' + fimLinha,
                HARDCODE.importacaoPosicaoInvestimentos, false, null, erros, nomeArquivo)

        if (!jsonRegistros.jsonRegistros[indexJsonRegistros].posicaoInvestimentos) {

            obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'P O S I Ç Ã O  D E T A L H A D A  D O S  AT I V O S' + fimLinha,
                fimLinha + 'Este material foi elaborado pela',
                    HARDCODE.importacaoPosicaoInvestimentos, true, null, erros, nomeArquivo)
    
            //obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'P O S I Ç Ã O  D E T A L H A D A  D O S  AT I V O S' + fimLinha,
            //    fimLinha + 'Este material foi elaborado pela XP INVESTIMENTOS CORRETORA DE CÂMBIO, TÍTULOS E VALORES MOBILIÁRIOS S.A., tem caráter meramente informativo, não constitui e nem deve ser' +
            //        fimLinha, HARDCODE.importacaoPosicaoInvestimentos, false, null, erros, nomeArquivo)

            //if (!jsonRegistros.jsonRegistros[indexJsonRegistros].posicaoInvestimentos) {
        
            //    obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'P O S I Ç Ã O  D E T A L H A D A  D O S  AT I V O S' + fimLinha,
            //        fimLinha + 'Este material foi elaborado pela XP INVESTIMENTOS CORRETORA DE CÂMBIO, TÍTULOS E VALORES MOBILIÁRIOS S.A., tem caráter meramente informativo, não deve ser utilizado para fins' +
            //            fimLinha, HARDCODE.importacaoPosicaoInvestimentos, true, null, erros, nomeArquivo)
            //}
        }
    }

    const linhasPosicaoInvestimentos = jsonRegistros.jsonRegistros[indexJsonRegistros].posicaoInvestimentos.split(fimLinha)
    let indexLinhasPosicaoInvestimentos = linhasPosicaoInvestimentos.length - 1

    const posicaoInvestimentos = []

    let posFinalDescricao
    let descricao
    let tipoRecursoFinanceiro
    let valor
    //let percRentabilidadeAnualRecursoFinanceiro
    let dataInicioRecursoFinanceiro = null
    let percRentabilidadeMesRecursoFinanceiro
    let percCDIMesRecursoFinanceiro
    let percRentabilidadeAnoRecursoFinanceiro
    let percCDIAnoRecursoFinanceiro
    let percRentabilidade12MRecursoFinanceiro
    let percCDI12MRecursoFinanceiro
    let percRentabilidade24MRecursoFinanceiro
    let percCDI24MRecursoFinanceiro
    let vencimento = null

    let dadosPosicaoInvestimentos

    indexLinhasPosicaoInvestimentos = 0

    while (indexLinhasPosicaoInvestimentos < linhasPosicaoInvestimentos.length) {

        if (linhasPosicaoInvestimentos[indexLinhasPosicaoInvestimentos].substring(0, 2) === 'R$') {

            linhasPosicaoInvestimentos[indexLinhasPosicaoInvestimentos] =
                linhasPosicaoInvestimentos[indexLinhasPosicaoInvestimentos - 2] + espaco +
                    linhasPosicaoInvestimentos[indexLinhasPosicaoInvestimentos - 1] + espaco +
                        linhasPosicaoInvestimentos[indexLinhasPosicaoInvestimentos]
        }

        indexLinhasPosicaoInvestimentos++
    } 
            
    indexLinhasPosicaoInvestimentos = linhasPosicaoInvestimentos.length - 1

    while (indexLinhasPosicaoInvestimentos >= 0) {

        if (linhasPosicaoInvestimentos[indexLinhasPosicaoInvestimentos].indexOf('R$') === -1) {

            linhasPosicaoInvestimentos.splice(indexLinhasPosicaoInvestimentos, 1)
        }

        indexLinhasPosicaoInvestimentos -= 1
    }

    indexLinhasPosicaoInvestimentos = 0

    while (indexLinhasPosicaoInvestimentos < linhasPosicaoInvestimentos.length) {

        posFinalDescricao = linhasPosicaoInvestimentos[indexLinhasPosicaoInvestimentos].indexOf('R$') - 1
        descricao = linhasPosicaoInvestimentos[indexLinhasPosicaoInvestimentos].substring(0, posFinalDescricao)

        const tipoRecursoFinanceiroAux = pesquisaList(linhaIntegracao.tipoRecursoFinanceiro, descricao).idConversao

        if (tipoRecursoFinanceiroAux) {

            tipoRecursoFinanceiro = tipoRecursoFinanceiroAux

        } else {

            dadosPosicaoInvestimentos =
                linhasPosicaoInvestimentos[indexLinhasPosicaoInvestimentos].substring(posFinalDescricao + 1).split(espaco)

            valor = trataValorTexto(dadosPosicaoInvestimentos[0])

            if (linhasPosicaoInvestimentos[indexLinhasPosicaoInvestimentos].indexOf('-R$') !== -1) {

                valor = valor * -1
            }

            if (valor === 0) {

                valor = '0.00'
            }

            if (dadosPosicaoInvestimentos.length === 9) {

                percRentabilidadeMesRecursoFinanceiro = trataPercentualTexto(dadosPosicaoInvestimentos[3])
                percCDIMesRecursoFinanceiro = trataPercentualTexto(dadosPosicaoInvestimentos[4])
                percRentabilidadeAnoRecursoFinanceiro = trataPercentualTexto(dadosPosicaoInvestimentos[5])
                percCDIAnoRecursoFinanceiro = trataPercentualTexto(dadosPosicaoInvestimentos[6])
                percRentabilidade24MRecursoFinanceiro = trataPercentualTexto(dadosPosicaoInvestimentos[7])
                percCDI24MRecursoFinanceiro = trataPercentualTexto(dadosPosicaoInvestimentos[8])

            } else {

                if (dadosPosicaoInvestimentos.length === 11) {

                    dataInicioRecursoFinanceiro = trataData(dadosPosicaoInvestimentos[8])
                    percRentabilidadeMesRecursoFinanceiro = trataPercentualTexto(dadosPosicaoInvestimentos[3])
                    percCDIMesRecursoFinanceiro = trataPercentualTexto(dadosPosicaoInvestimentos[4])
                    percRentabilidadeAnoRecursoFinanceiro = trataPercentualTexto(dadosPosicaoInvestimentos[5])
                    percCDIAnoRecursoFinanceiro = trataPercentualTexto(dadosPosicaoInvestimentos[6])
                }
            }
            
            vencimento = identificaDataComBaseSiglaMesAnoString(descricao)

            //Não deu certo
            //percRentabilidadeAnualRecursoFinanceiro =
            //    round(jsonRegistros.jsonRegistros[indexJsonRegistros].taxaCDI12Meses *
            //        (trataPercentualTexto(dadosPosicaoInvestimentos[10]) / 100), 2)

            //Problema com conversão de taxas negativas
            //if (dadosPosicaoInvestimentos[dadosPosicaoInvestimentos.length - 3].indexOf('/')) {

            //    percRentabilidadeAnualRecursoFinanceiro =
            //        converteTaxaMensalEmAnual(
            //            converteTaxaEmMensal(
            //                trataPercentualTexto(dadosPosicaoInvestimentos[dadosPosicaoInvestimentos.length - 2]),
            //                    calculaMeses2Datas(trataData(dadosPosicaoInvestimentos[dadosPosicaoInvestimentos.length - 3]),
            //                        somaMesesData(jsonRegistros.jsonRegistros[indexJsonRegistros].dataReferencia, -1)
            //                    )
            //            )
            //        )
            //}

            incluiPosicaoInvestimentos(posicaoInvestimentos, tipoRecursoFinanceiro, descricao,
                valor/*, percRentabilidadeAnualRecursoFinanceiro*/,
                    jsonRegistros.jsonRegistros[indexJsonRegistros].instituicaoFinanceira, dataInicioRecursoFinanceiro,
                        percRentabilidadeMesRecursoFinanceiro, percCDIMesRecursoFinanceiro, percRentabilidadeAnoRecursoFinanceiro,
                            percCDIAnoRecursoFinanceiro, percRentabilidade12MRecursoFinanceiro, percCDI12MRecursoFinanceiro,
                                percRentabilidade24MRecursoFinanceiro, percCDI24MRecursoFinanceiro, vencimento)
        }

        indexLinhasPosicaoInvestimentos++
    }

    jsonRegistros.indexInicial = 0

    trataCaixaProventos(PDFTxt, jsonRegistros, erros, nomeArquivo, indexJsonRegistros, posicaoInvestimentos, 'Caixa')
    
    trataCaixaProventos(PDFTxt, jsonRegistros, erros, nomeArquivo, indexJsonRegistros, posicaoInvestimentos, 'Proventos')

   

    jsonRegistros.jsonRegistros[indexJsonRegistros].posicaoInvestimentos = posicaoInvestimentos

    /*
    erros.push('teste'
        .replace("$numeroProposta$", 'xxx')
            .replace("$codigoAgente$", 'yyy')
    )
console.log(jsonRegistros)
            */


    jsonRegistrosJsonRegistrosAtualizaErros(jsonRegistros, erros)



    return jsonRegistros.jsonRegistros
}